
// import React, { useEffect, useState } from "react";
// import "../assets/Loan/SingleLoanEmiPay.css";
// import Select from "react-select";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";

// const SingleLoanEmiPay = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { profile } = useSelector((state) => state.userProfile);

//   const [loans, setLoans] = useState([]);
//   const [selectedLoan, setSelectedLoan] = useState(null);
//   const [lastPaidEmi, setLastPaidEmi] = useState(null);
//   const [currentPendingEmi, setCurrentPendingEmi] = useState(null);
//   const [fullLoanEmiData, setFullLoanEmiData] = useState([]);
//   const [showPreview, setShowPreview] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [payLoading, setPayLoading] = useState(false);
//   const [totalInstallments, setTotalInstallments] = useState(0);

//   const [formData, setFormData] = useState({
//     amount: "",
//     paymentMode: "CASH",
//     paymentType: "full",
//     transactionDate: new Date().toISOString().split("T")[0],
//     narration: "",
//   });

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   useEffect(() => {
//     if (profile) fetchLoansList();
//   }, [profile]);

//   useEffect(() => {
//     if (selectedLoan?.id) {
//       fetchEmiDetails(selectedLoan.id);
//     }
//   }, [selectedLoan]);

//   const fetchLoansList = async () => {
//     try {
//       const superAdminId = profile?.superAdminId || 14;
//       const branchId = localStorage.getItem("userId") || 56;
//       const res = await axios.get(`${API_URL}/get-all-loan-sgd`, {
//         params: { superAdminId, branchId },
//       });
//       setLoans(res.data.data || []);
//     } catch (err) {
//       console.error("Error fetching loans:", err);
//     }
//   };

//   const fetchEmiDetails = async (loanId) => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API_URL}/get-loanemi/with-panalty/${loanId}`);
//       const loanEmiData = res.data.emis || [];
//       setFullLoanEmiData(loanEmiData);
//       setTotalInstallments(res.data.count || 0);

//       const pending = [...loanEmiData]
//         .sort((a, b) => a.emiNumber - b.emiNumber)
//         .find((item) => item.status.toLowerCase() === "pending");

//       setCurrentPendingEmi(pending);

//       if (pending) {
//         setFormData((prev) => ({ 
//           ...prev, 
//           amount: pending.emiAmount, 
//           paymentType: "full" 
//         }));
//       }

//       const paid = [...loanEmiData]
//         .sort((a, b) => b.emiNumber - a.emiNumber)
//         .find((item) => item.status.toLowerCase() === "paid");
//       setLastPaidEmi(paid);
//     } catch (err) {
//       toast.error("Failed to load EMI schedule");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handlePreview = (e) => {
//     e.preventDefault();
//     if (!selectedLoan) return toast.warn("Please select a Loan Account");
//     if (!currentPendingEmi && formData.paymentType !== "advance") {
//         return toast.error("No pending installments found for this loan");
//     }
    
//     // Validation for Partial
//     if(formData.paymentType === "partial" && Number(formData.amount) >= Number(currentPendingEmi?.emiAmount)) {
//         return toast.error("Partial amount must be less than EMI amount. Use Full Payment instead.");
//     }

//     setShowPreview(true);
//   };

//   const handleSubmit = async () => {
//     try {
//       setPayLoading(true);
//       const { amount, paymentMode, paymentType, transactionDate, narration } = formData;
//       const loanId = selectedLoan.id;
//       const emiNo = currentPendingEmi?.emiNumber;

//       let finalUrl = "";
//       let payload = {};

//       if (paymentType === "advance") {
//         finalUrl = `${API_URL}/loan/advance-payment/${loanId}`;
//         payload = { amount: Number(amount), paymentMode, paymentDate: transactionDate, remarks: narration };
//       } else if (paymentType === "partial") {
//         finalUrl = `${API_URL}/loan/pay-emi-new?loanId=${loanId}&emiNumber=${emiNo}&paymentType=partial`;
//         payload = { amountPaid: Number(amount), paymentMode, paymentDate: transactionDate, remarks: narration };
//       } else {
//         finalUrl = `${API_URL}/loan/pay-emi/withpanalty?loanId=${loanId}&emiNumber=${emiNo}`; 
//         payload = {
//           loanId: loanId,
//           emiNumber: emiNo,
//           amountPaid: Number(amount),
//           paymentMode: paymentMode,
//           paymentDate: transactionDate,
//           collectedBy: localStorage.getItem("userId") || 1,
//           remarks: narration || `EMI ${emiNo} Payment`,
//         };
//       }

//       const res = await axios.post(finalUrl, payload);
//       toast.success(res.data.message || "Payment Processed Successfully!");
//       setShowPreview(false);
//       await fetchEmiDetails(loanId);
//       // Navigate to receipt
//       navigateToReceipt(currentPendingEmi);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "An error occurred during payment");
//     } finally {
//       setPayLoading(false);
//     }
//   };

//   const navigateToReceipt = (emiObj) => {
//     if (!emiObj) return;
//     const nextEmi = fullLoanEmiData.find(item => item.emiNumber === emiObj.emiNumber + 1);
//     navigate("/Banking/DepositAccount/Depositemireciept", {
//       state: { loanAccount: selectedLoan, emi: emiObj, nextemi: nextEmi || null },
//     });
//   };

//   return (
//     <div className="saving-account-transaction-container">
//       <h2>Single Loan EMI Payment Portal</h2>

//       <form className="saving-account-transaction-payment-details" onSubmit={handlePreview}>
//         <h4><i className="fa-solid fa-calendar-check"></i> EMI Schedule Summary</h4>

//         {selectedLoan && (
//           <div className="scheme-details-banner">
//             <h4><i className="fa-solid fa-circle-info"></i> Scheme Info:</h4>
//             <div className="scheme-info-grid">
//               <div className="info-item"><span>ROI:</span> <strong>{selectedLoan.loanRoi}%</strong></div>
//               <div className="info-item"><span>Freq:</span> <strong>{selectedLoan.loanRecoveryFrequency}</strong></div>
//               <div className="info-item"><span>Status:</span> 
//                 <strong className={`status-${selectedLoan.status?.toLowerCase()}`}>{selectedLoan.status}</strong>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="payment-details-inputs">
//           <label>Installment Progress</label>
//           <div className="progress-bar-container">
//             <div
//               className="progress-fill"
//               style={{ width: `${totalInstallments > 0 ? (lastPaidEmi?.emiNumber / totalInstallments) * 100 : 0}%` }}
//             ></div>
//             <span className="progress-text">
//               {lastPaidEmi?.emiNumber || 0} / {totalInstallments || 0} Paid
//             </span>
//           </div>
//         </div>

//         <div className="payment-details-container">
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Select Loan Account</label>
//               <Select
//                 placeholder="Search Loan..."
//                 options={loans.map((loan) => ({
//                   value: loan.id,
//                   label: `${loan?.userName} | ${loan.loanAccountNumber}`,
//                   loanAccount: loan,
//                 }))}
//                 onChange={(selected) => {
//                   setFormData(prev => ({ ...prev, amount: "" })); 
//                   setSelectedLoan(selected?.loanAccount);
//                 }}
//                 isSearchable
//               />
//             </div>

//             <div className="payment-details-inputs">
//               <label>Last Paid EMI (Receipt)</label>
//               <div className="input-with-button">
//                 <input
//                   type="text"
//                   value={lastPaidEmi ? `EMI #${lastPaidEmi.emiNumber} - Paid` : "No Record Found"}
//                   readOnly
//                 />
//                 {lastPaidEmi && (
//                   <button type="button" className="receipt-action-btn" onClick={() => navigateToReceipt(lastPaidEmi)}>
//                     <i className="fa-solid fa-print"></i>
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Next Due Date</label>
//               <input
//                 className="due-date-input-highlight"
//                 type="text"
//                 value={currentPendingEmi ? new Date(currentPendingEmi.dueDate).toLocaleDateString("en-IN") : "No Pending EMI"}
//                 readOnly
//               />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Current EMI Amount</label>
//               <input
//                 type="text"
//                 value={currentPendingEmi ? `₹ ${currentPendingEmi.emiAmount}` : "₹ 0.00"}
//                 readOnly
//               />
//             </div>
//           </div>

//           <div className="payment-type-card-wrapper">
//             <div className="payment-details-input-groups">
//                 <div className="payment-details-inputs">
//                     <label>Payment Mode</label>
//                     <select name="paymentMode" value={formData.paymentMode} onChange={handleChange}>
//                         <option value="CASH">💵 CASH</option>
//                         <option value="UPI">📱 UPI</option>
//                         <option value="RTGS">🏦 NEFT/RTGS</option>
//                     </select>
//                 </div>
//                 <div className="payment-details-inputs">
//                     <label>Payment Action</label>
//                     <select 
//                         className={`type-select-box ${formData.paymentType}`}
//                         name="paymentType" 
//                         value={formData.paymentType} 
//                         onChange={(e) => {
//                             const val = e.target.value;
//                             setFormData(prev => ({
//                                 ...prev,
//                                 paymentType: val,
//                                 amount: val === "full" ? (currentPendingEmi?.emiAmount || "") : prev.amount
//                             }));
//                         }}
//                     >
//                         <option value="full">Full Installment</option>
//                         <option value="partial">Partial Payment</option>
//                         <option value="advance">Advance Payment</option>
//                     </select>
//                 </div>
//             </div>

//             <div className="payment-details-input-groups">
//                 <div className="payment-details-inputs">
//                     <label>Amount to Collect (INR)</label>
//                     <input 
//                         type="number" 
//                         name="amount" 
//                         value={formData.amount} 
//                         onChange={handleChange} 
//                         readOnly={formData.paymentType === "full"}
//                         className={formData.paymentType !== "full" ? "editable-amount" : ""}
//                         placeholder="0.00"
//                     />
//                     {formData.paymentType === 'partial' && <span className="helper-text orange">Remaining balance will be due later.</span>}
//                     {formData.paymentType === 'advance' && <span className="helper-text green">This will be added as extra credit.</span>}
//                 </div>
//                 <div className="payment-details-inputs">
//                     <label>Collection Date</label>
//                     <input type="date" name="transactionDate" value={formData.transactionDate} onChange={handleChange} />
//                 </div>
//             </div>
//           </div>

//           <div className="payment-details-inputs">
//             <label>Transaction Remarks</label>
//             <input type="text" name="narration" value={formData.narration} onChange={handleChange} placeholder="Add a note here..." />
//           </div>
//         </div>

//         <div className="pay-btn">
//           <button type="submit" disabled={(!currentPendingEmi && formData.paymentType !== 'advance') || loading}>
//             {loading ? "Refreshing Details..." : "Verify & Generate Receipt"}
//           </button>
//         </div>
//       </form>

//       {showPreview && (
//         <div className="modal-overlay">
//           <div className={`transaction-modal border-${formData.paymentType}`}>
//             <h3>Confirm {formData.paymentType.toUpperCase()} Payment</h3>
//             <div className="modal-content">
//               <div className="modal-row"><span>Customer:</span> <strong>{selectedLoan?.userName}</strong></div>
//               {formData.paymentType !== 'advance' && (
//                   <div className="modal-row"><span>EMI Number:</span> <strong>#{currentPendingEmi?.emiNumber}</strong></div>
//               )}
//               <div className="modal-row amount-row">
//                 <span>Net Payable:</span> 
//                 <strong className="final-amount">₹ {Number(formData.amount).toLocaleString('en-IN')}</strong>
//               </div>
//               <div className="modal-info-badge">
//                 Mode: {formData.paymentMode} | Date: {formData.transactionDate}
//               </div>
//             </div>
//             <div className="modal-actions">
//               <button className="cancel-btn" onClick={() => setShowPreview(false)} disabled={payLoading}>Edit</button>
//               <button className="confirm-btn" onClick={handleSubmit} disabled={payLoading}>
//                 {payLoading ? "Processing..." : "Confirm Pay"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SingleLoanEmiPay;




import React, { useEffect, useState } from "react";
import "../assets/Loan/SingleLoanEmiPay.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const SingleLoanEmiPay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state.userProfile);

  const [loans, setLoans] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [lastPaidEmi, setLastPaidEmi] = useState(null);
  const [currentPendingEmi, setCurrentPendingEmi] = useState(null);
  const [fullLoanEmiData, setFullLoanEmiData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payLoading, setPayLoading] = useState(false);
  const [totalInstallments, setTotalInstallments] = useState(0);

  const [formData, setFormData] = useState({
    amount: "",
    penaltyAmount: 0,
    overdueDays: 0,
    perDayPenalty: 0,
    totalPayable: "",
    paymentMode: "CASH",
    transactionDate: new Date().toISOString().split("T")[0],
    narration: "",
  });

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile) fetchLoansList();
  }, [profile]);

  useEffect(() => {
    if (selectedLoan?.id) {
      fetchEmiDetails(selectedLoan.id);
    }
  }, [selectedLoan]);

  const fetchLoansList = async () => {
    try {
      const superAdminId = profile?.superAdminId || 14;
      const userId = localStorage.getItem("userId") || 56;
      const res = await axios.get(`${API_URL}/get-all-loan-sgd`, {
        params: { superAdminId, userId },
      });
      const filteredLoan=res.data.data.filter((l)=>l.status.toLowerCase()!=="closed")
      setLoans(filteredLoan || []);
    } catch (err) {
      console.error("Error fetching loans:", err);
    }
  };

  const fetchEmiDetails = async (loanId) => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/get-loanemi/with-panalty/${loanId}`);
      const loanEmiData = res.data.emis || [];
      setFullLoanEmiData(loanEmiData);
      setTotalInstallments(res.data.count || 0);

      const pending = [...loanEmiData]
        .sort((a, b) => a.emiNumber - b.emiNumber)
        .find((item) => item.status.toLowerCase() === "pending");

      setCurrentPendingEmi(pending);

      if (pending) {
        const penalty = Number(pending.penalty || 0);
        const baseEmi = Number(pending.emiAmount || 0);
        const days = Number(pending.overdueDays || 0);
        const perDay = Number(pending.perDayPenalty || 0);

        setFormData((prev) => ({ 
          ...prev, 
          amount: baseEmi,
          penaltyAmount: penalty,
          overdueDays: days,
          perDayPenalty: perDay,
          totalPayable: baseEmi + penalty 
        }));
      } else {
        setFormData((prev) => ({ 
          ...prev, amount: "", penaltyAmount: 0, overdueDays: 0, perDayPenalty: 0, totalPayable: "" 
        }));
      }

      const paid = [...loanEmiData]
        .sort((a, b) => b.emiNumber - a.emiNumber)
        .find((item) => item.status.toLowerCase() === "paid");
      setLastPaidEmi(paid);

    } catch (err) {
      toast.error("Failed to load EMI schedule");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const navigateToReceipt = (emiObj) => {
    if (!emiObj || !fullLoanEmiData) return;
    const nextEmi = fullLoanEmiData.find((item) => item.emiNumber === emiObj.emiNumber + 1);
    navigate("/Loan/SingleLoanEmiReceipt", {
      state: { loanAccount: selectedLoan, emi: emiObj, nextemi: nextEmi || null },
    });
  };

  const handlePreview = (e) => {
    e.preventDefault();
    if (!selectedLoan) return toast.warn("Please select a Loan Account");
    if (!currentPendingEmi) return toast.error("No pending installments found");
    setShowPreview(true);
  };

  // const handleSubmit = async () => {
  //   try {
  //     setPayLoading(true);
  //     const { totalPayable, paymentMode, transactionDate, narration, penaltyAmount } = formData;
  //     const loanId = selectedLoan.id;
  //     const emiNo = currentPendingEmi.emiNumber;

  //     const payload = {
  //       loanId: loanId,
  //       emiNumber: emiNo,
  //       amountPaid: Number(totalPayable),
  //       penaltyAmount: Number(penaltyAmount),
  //       paymentMode: paymentMode,
  //       paymentDate: transactionDate,
  //       collectedBy: localStorage.getItem("userId") || 1,
  //       remarks: narration || `EMI ${emiNo} Full Payment with Penalty`,
  //     };

  //     const res = await axios.post(`${API_URL}/loan/pay-emi/withpanalty?loanId=${loanId}&emiNumber=${emiNo}`, payload);

  //     toast.success(res.data.message || "EMI Payment Successful!");
  //     setShowPreview(false);
  //     await fetchEmiDetails(loanId);
  //     navigateToReceipt(currentPendingEmi);
  //   } catch (err) {
  //     toast.error(err.response?.data?.message || "An error occurred");
  //   } finally {
  //     setPayLoading(false);
  //   }
  // };

  const handleSubmit = async () => {
  try {
    setPayLoading(true);
    const { totalPayable, paymentMode, transactionDate, narration, penaltyAmount } = formData;
    const loanId = selectedLoan.id;
    const emiNo = currentPendingEmi.emiNumber;

    const payload = {
      loanId: loanId,
      emiNumber: emiNo,
      amountPaid: Number(totalPayable),
      penaltyAmount: Number(penaltyAmount),
      paymentMode: paymentMode,
      paymentDate: transactionDate,
      collectedBy: localStorage.getItem("userId") || 1,
      remarks: narration || `EMI ${emiNo} Full Payment with Penalty`,
    };

    const res = await axios.post(`${API_URL}/loan/pay-emi/withpanalty?loanId=${loanId}&emiNumber=${emiNo}`, payload);

    toast.success(res.data.message || "EMI Payment Successful!");
    setShowPreview(false);
    const refreshRes = await axios.get(`${API_URL}/get-loanemi/with-panalty/${loanId}`);
    const updatedEmis = refreshRes.data.emis || [];
    const justPaidEmi = updatedEmis.find(item => item.emiNumber === emiNo);
    const nextEmi = updatedEmis.find(item => item.emiNumber === emiNo + 1);

    navigate("/Loan/SingleLoanEmiReceipt", {
      state: { 
        loanAccount: selectedLoan, 
        emi: justPaidEmi, 
        nextemi: nextEmi || null 
      },
    });

  } catch (err) {
    toast.error(err.response?.data?.message || "An error occurred");
  } finally {
    setPayLoading(false);
  }
};

  // Logic to calculate progress safely
  const calculateProgress = () => {
    if (!totalInstallments || totalInstallments === 0) return 0;
    const paidCount = lastPaidEmi?.emiNumber || 0;
    return (paidCount / totalInstallments) * 100;
  };

  return (
    <div className="single-loan-portal-container">
      <h2 className="single-loan-portal-title">Single Loan EMI Payment</h2>

      <form className="single-loan-form-card" onSubmit={handlePreview}>
        <h4 className="single-loan-section-header">
          <i className="fa-solid fa-calendar-check"></i> EMI Schedule Summary
        </h4>

        {selectedLoan && (
          <div className="single-loan-scheme-banner">
            <h4 className="banner-title"><i className="fa-solid fa-circle-info"></i> Loan Details</h4>
            <div className="single-loan-scheme-grid">
              <div className="scheme-cell"><span>ROI</span> <strong>{selectedLoan.loanRoi}%</strong></div>
              <div className="scheme-cell"><span>Frequency</span> <strong>{selectedLoan.loanRecoveryFrequency}</strong></div>
              <div className="scheme-cell"><span>Status</span> 
                <strong className={`status-label status-${selectedLoan.status?.toLowerCase()}`}>{selectedLoan.status}</strong>
              </div>
            </div>
          </div>
        )}

        <div className="single-loan-progress-section">
          <label className="input-field-label">Payment Progress</label>
          <div className="custom-progress-container">
            <div
              className="custom-progress-fill"
              style={{ width: `${calculateProgress()}%` }}
            ></div>
            <span className="custom-progress-text">
              {lastPaidEmi?.emiNumber || 0} / {totalInstallments || 0} Installments Paid
            </span>
          </div>
        </div>

        <div className="single-loan-form-inputs">
          <div className="input-row-grid">
            <div className="field-container">
              <label className="input-field-label">Loan Account Search</label>
              <Select
                className="loan-react-select"
                placeholder="Search Account..."
                options={loans.map((loan) => ({
                  value: loan.id,
                  label: `${loan?.userName} | ${loan.loanAccountNumber}`,
                  loanAccount: loan,
                }))}
                onChange={(selected) => {
                  setFormData(prev => ({ ...prev, amount: "", penaltyAmount: 0, totalPayable: "" })); 
                  setSelectedLoan(selected?.loanAccount);
                }}
                isSearchable
              />
            </div>

            <div className="field-container">
              <label className="input-field-label">Last Receipt</label>
              <div className="input-group-with-btn">
                <input
                  className="input-readonly"
                  type="text"
                  value={lastPaidEmi ? `EMI #${lastPaidEmi.emiNumber} Paid` : "No Record"}
                  readOnly
                />
                {lastPaidEmi && (
                  <button type="button" className="btn-icon-print" onClick={() => navigateToReceipt(lastPaidEmi)}>
                    <i className="fa-solid fa-print"></i>
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="input-row-grid">
            <div className="field-container">
              <label className="input-field-label">Upcoming Due Date</label>
              <input
                className="input-readonly highlight-due"
                type="text"
                value={
                    currentPendingEmi 
                    ? new Date(currentPendingEmi.dueDate).toLocaleDateString("en-IN") 
                    : (totalInstallments > 0 && (lastPaidEmi?.emiNumber === totalInstallments) ? "COMPLETED" : "N/A")
                }
                readOnly
              />
            </div>
            <div className="field-container">
              <label className="input-field-label">Base EMI Amount</label>
              <input
                className="input-readonly"
                type="text"
                value={currentPendingEmi ? `₹ ${currentPendingEmi.emiAmount}` : "₹ 0.00"}
                readOnly
              />
            </div>
          </div>

          {/* Penalty Breakdown Box */}
          {formData.penaltyAmount > 0 && (
            <div className="penalty-breakdown-card">
              <div className="penalty-card-header">
                <i className="fa-solid fa-triangle-exclamation"></i> Late Payment Overdue Details
              </div>
              <div className="penalty-card-body">
                <div className="p-item"><span>Overdue Days</span><strong>{formData.overdueDays} Days</strong></div>
                <div className="p-item"><span>Penalty/Day</span><strong>₹ {formData.perDayPenalty}</strong></div>
                <div className="p-item p-highlight"><span>Total Penalty</span><strong>₹ {formData.penaltyAmount}</strong></div>
              </div>
            </div>
          )}

          <div className="custom-divider"></div>

          <div className="input-row-grid">
            <div className="field-container">
              <label className="input-field-label">Calculated Penalty (INR)</label>
              <input
                className={`input-readonly ${formData.penaltyAmount > 0 ? "penalty-active-box" : ""}`}
                type="text"
                value={`₹ ${formData.penaltyAmount}`}
                readOnly
              />
            </div>
            <div className="field-container">
              <label className="input-field-label">Total Collection Amount</label>
              <input
                className="input-readonly final-collection-highlight"
                type="text"
                value={formData.totalPayable ? `₹ ${formData.totalPayable}` : "₹ 0.00"}
                readOnly
              />
            </div>
          </div>

          <div className="input-row-grid">
            <div className="field-container">
              <label className="input-field-label">Payment Mode</label>
              <select className="custom-select-input" name="paymentMode" value={formData.paymentMode} onChange={handleChange}>
                <option value="CASH">💵 CASH</option>
                <option value="UPI">📱 UPI</option>
                <option value="RTGS">🏦 NEFT/RTGS</option>
              </select>
            </div>
            <div className="field-container">
              <label className="input-field-label">Collection Date</label>
              <input className="custom-date-input" type="date" name="transactionDate" value={formData.transactionDate} onChange={handleChange} />
            </div>
          </div>

          <div className="field-container">
            <label className="input-field-label">Remarks</label>
            <input className="custom-text-input" type="text" name="narration" value={formData.narration} onChange={handleChange} placeholder="Optional narration" />
          </div>
        </div>

        <div className="form-submit-section">
          <button className="btn-confirm-pay" type="submit" disabled={!currentPendingEmi || loading}>
            {loading ? "Syncing..." : "Process Payment & Generate Receipt"}
          </button>
        </div>
      </form>

      {showPreview && (
        <div className="modal-overlay-bg">
          <div className="preview-modal-box">
            <h3 className="modal-header-title">Confirm Collection</h3>
            <div className="modal-body-content">
              <div className="modal-info-row"><span>Customer Name:</span> <strong>{selectedLoan?.userName}</strong></div>
              <div className="modal-info-row"><span>Installment No:</span> <strong>{currentPendingEmi?.emiNumber}</strong></div>
              
              <div className="modal-divider-light"></div>
              
              <div className="modal-info-row"><span>Base EMI Amount:</span> <strong>₹ {formData.amount}</strong></div>
              
              {formData.penaltyAmount > 0 && (
                <div className="modal-info-row text-danger-penalty">
                  <span>Late Fee ({formData.overdueDays} Days):</span> 
                  <strong>+ ₹ {formData.penaltyAmount}</strong>
                </div>
              )}

              <div className="modal-info-row total-payable-row">
                <span>Net Payable:</span> 
                <strong>₹ {formData.totalPayable}</strong>
              </div>
            </div>
            <div className="modal-action-footer">
              <button className="btn-modal-cancel" onClick={() => setShowPreview(false)}>Edit</button>
              <button className="btn-modal-submit" onClick={handleSubmit} disabled={payLoading}>
                {payLoading ? "Processing..." : "Confirm Pay"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleLoanEmiPay;